import React from "react";
import styles from "./Header.module.scss";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { useQuery } from "react-query";
import { getPublicSettings, getUserInfo } from "../../ApiService";
import UserIcon from "../../icons/account.svg";
import MarketplaceSwitch from "../MarketplaceSwitch/MarketplaceSwitch";
import { useMarketplace } from "../../contexts/MarketplaceContext";

const Header: React.FC = () => {
  const location = useLocation();
  const { data: userInfo } = useQuery("userInfo", getUserInfo);
  const { data: settings } = useQuery("settings", getPublicSettings);
  const { currentMarketplace, isWB } = useMarketplace();

  const userName = userInfo?.name
    ? `${userInfo.name} (${userInfo.tokenBalance})`
    : "";

  const marketplaceName = isWB ? "WB" : "Ozon";

  const managementOption =
    userInfo?.type === "admin"
      ? { path: "/management", icon: undefined, text: "Управление" }
      : null;

  const links = [
    { path: "/stores", icon: undefined, text: `Магазины ${marketplaceName}` },
    { path: "/feedback/unanswered", icon: undefined, text: `Отзывы ${marketplaceName}` },
    { path: "/questions/unanswered", icon: undefined, text: `Вопросы ${marketplaceName}` },
    { path: "/lk", icon: UserIcon, text: userName },
    ...(managementOption ? [managementOption] : []),
  ];

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    window.location.replace("/login");
  };

  return (
    <header className={styles.header}>
      <div className={styles.contentContainer}>
        <div className={styles.leftSection}>
          <MarketplaceSwitch />
        </div>
        <div className={styles.centerSection}>
          {links.map((link) => (
            <Link
              to={link.path}
              className={classNames(styles.link, {
                [styles.active]:
                  location.pathname.includes(link.path) ||
                  link.path.includes(location.pathname),
              })}
              key={link.path}
            >
              {link.icon && (
                <img
                  src={link.icon}
                  alt="User Icon"
                  className="inline-block w-7 h-7 mr-2 fill-current text-black-800"
                />
              )}
              {link.text}
            </Link>
          ))}
        </div>
        <div className={styles.rightSection}>
          <Link onClick={handleLogout} to={"/login"} className={styles.link}>
            Выход
          </Link>
          {settings?.showAdminLink && (
            <a
              href={settings.adminLink}
              className={styles.link}
              target="_blank"
              rel="noreferrer"
            >
              Помощь
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
